import {productMenuPlugin} from '../plugins/productMenuPlugin'; export const pluginsRegistry = {'product-menu': productMenuPlugin,};